import React from "react";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { AnalyzePageDesktop } from "./AnalyzePage.Desktop";
import { AnalyzePageMobile } from "./AnalyzePage.Mobile";

/**
 * Analyze Page - Allows users to analyze any token
 * Desktop: Full layout with sidebar
 * Mobile: Single column with Show more, optimized for small screens
 */
export const AnalyzePage: React.FC = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return isDesktop ? <AnalyzePageDesktop /> : <AnalyzePageMobile />;
};
